module.exports = __webpack_public_path__ + "img/chevron_down.7f7cee98.svg";